var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorchecking = function SvgErrorchecking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M2.966 5.867h27.068V3.45a.485.485 0 0 0-.483-.483H3.448a.485.485 0 0 0-.483.483zm27.55.966H2.482A.48.48 0 0 1 2 6.35v-2.9C2 2.65 2.649 2 3.45 2h26.1c.8 0 1.45.65 1.45 1.45v2.9a.483.483 0 0 1-.484.483M7.316 11.667h-2.9a.482.482 0 0 1 0-.967h2.9a.483.483 0 1 1 0 .967M10.217 9.734H4.415a.483.483 0 0 1 0-.967h5.802a.484.484 0 0 1 0 .967",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M18.917 27.134H3.449c-.8 0-1.449-.65-1.449-1.45V3.45C2 2.65 2.649 2 3.45 2h26.1c.8 0 1.45.65 1.45 1.45v19.818a.483.483 0 1 1-.966 0V3.45a.484.484 0 0 0-.483-.483H3.448a.484.484 0 0 0-.483.483v22.234c0 .267.217.483.483.483h15.468a.484.484 0 0 1 0 .967",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M22.31 21.344a.486.486 0 0 0 0 .684l1.368 1.367a.484.484 0 0 0 .684-.684l-1.368-1.367a.484.484 0 0 0-.684 0",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.233 16.5a6.767 6.767 0 1 1-13.534.001 6.767 6.767 0 0 1 13.534 0",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBC8F2",
    fillRule: "evenodd",
    d: "M24.717 16.5a7.25 7.25 0 1 1-14.5 0 7.25 7.25 0 0 1 7.249-7.25 7.25 7.25 0 0 1 7.25 7.25",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M17.466 9.734c-3.73 0-6.766 3.036-6.766 6.766s3.035 6.767 6.766 6.767a6.775 6.775 0 0 0 6.767-6.767 6.775 6.775 0 0 0-6.767-6.766m0 14.5c-4.263 0-7.733-3.47-7.733-7.734s3.47-7.733 7.733-7.733c4.265 0 7.734 3.47 7.734 7.733 0 4.265-3.47 7.734-7.734 7.734",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBC8F2",
    fillRule: "evenodd",
    d: "M29.067 29.551a1.44 1.44 0 0 1-1.025-.425l-3.867-3.867a1.44 1.44 0 0 1-.424-1.025c0-.387.15-.751.424-1.025a1.44 1.44 0 0 1 1.025-.425c.387 0 .752.151 1.025.425l3.867 3.867c.273.273.424.638.424 1.025s-.151.751-.424 1.025a1.44 1.44 0 0 1-1.025.425",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M25.2 22.3c-.516 0-1.002.202-1.367.567-.366.366-.566.85-.566 1.367 0 .516.2 1.002.566 1.367l3.866 3.867c.365.365.851.566 1.368.566a1.92 1.92 0 0 0 1.367-.566c.366-.365.566-.85.566-1.367 0-.516-.2-1.002-.566-1.367l-3.868-3.867a1.92 1.92 0 0 0-1.366-.566m0 .967c.248 0 .495.095.684.284l3.867 3.867a.966.966 0 1 1-1.368 1.367l-3.866-3.867a.966.966 0 0 1 .683-1.65M22.606 17.946a.485.485 0 0 0-.625.28 4.86 4.86 0 0 1-4.515 3.108.482.482 0 0 0 0 .967c2.389 0 4.567-1.5 5.418-3.73a.483.483 0 0 0-.278-.625M22.783 16.04c-.268 0-.483.238-.483.505a.483.483 0 1 0 .967 0V16.5c0-.267-.217-.46-.484-.46",
    clipRule: "evenodd"
  })));
};
export default SvgErrorchecking;